<template>
  <div id="tutorial-settings-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog" style="width: 400px">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">TUTORIAL SETTINGS</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <vue-spinner v-if="loading"></vue-spinner>

              <template v-else>
                <div class="form-group">
                  <label for="tutorial-header">Header</label>
                  <input class="form-control" type="text" autocomplete="off" placeholder="Header" name="tutorial-header" id="tutorial-header" v-model="tutorialData.header">
                </div>
                <div class="form-group">
                  <label for="tutorial-subheader">Subheader</label>
                  <input class="form-control" type="text" autocomplete="off" placeholder="Subheader" name="tutorial-subheader" id="tutorial-subheader" v-model="tutorialData.subheader">
                </div>
                <div class="form-group">
                  <label for="tutorial-download-as">Download as (filename)</label>
                  <input class="form-control" type="text" autocomplete="off" placeholder="File name" name="tutorial-download-as" id="tutorial-download-as" v-model="tutorialData.filename">
                </div>
                <div class="form-group">
                  <label for="tutorial-category">Category</label>
                  <select class="form-control" v-model="tutorialCategoryId" id="tutorial-category">
                    <option v-for="category in categories" :value="category.id">{{category.title}}</option>
                  </select>
                </div>

                <div v-if="tutorialData.thumbFile || thumb.length" class="thumb-preview">
                  <img :src="thumbUrl()" alt="">
                </div>

                <div class="upload-thumb">
                  <div class="example-btn">
                    <file-upload
                        class="btn green"
                        :post-action="uploadEndpoint"
                        :data="{'tutorialId': id}"
                        extensions="jpg,png,jpeg"
                        accept="image/png,image/jpg,image/jpeg"
                        :multiple="false"
                        :size="1024 * 1024 * 10"
                        v-model="thumb"
                        @input-filter="inputFilter"
                        @input-file="inputFile"
                        :headers="{'token' : token}"
                        :input-id="'tutorial-upload-thumb'"
                        ref="thumbUpload">
                      <i class="fa fa-plus"></i> Upload thumb file
                    </file-upload>
                    <div class="pull-right">
                      <vue-spinner v-if="loadingThumb"></vue-spinner>
                    </div>
                  </div>
                </div>

              </template>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button :disabled="loading" class="btn green" @click.prevent="updateSettings">Save changes</button>
          <button :disabled="loading" class="btn green" @click.prevent="removeTutorial">Remove tutorial</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {BACKEND_URL, BUCKET_URL, HTTP, ERROR} from "@/http-common";
  import Spinner from "@/components/Spinner";
  import VueUploadComponent from 'vue-upload-component';
  import {mapGetters} from "vuex";

  export default {
    name: 'TutorialSettingsModal',
    components: {
      'VueSpinner': Spinner,
      'file-upload': VueUploadComponent,
    },
    props: ['id', 'categories'],
    data() {
      return {
        loading: false,
        loadingThumb: false,
        tutorialData: {
          header: null,
          subheader: null,
          thumbFile: null,
          filename: ''
        },
        thumb: [],
        tutorialCategoryId: null,
        uploadEndpoint: BACKEND_URL + 'tutorials/upload-thumb-file'
      }
    },
    computed: {
      ...mapGetters({
        user: 'getUser'
      }),
      token: function () {
        return localStorage.getItem('id_token');
      },
    },
    mounted() {
      $('#tutorial-settings-modal').modal('show');

      this.loading = true;
      HTTP.get('tutorials/get/' + this.id).then(response => {
        ERROR(response);
        this.loading = false;
        this.tutorialData = response.data.data.tutorial;
        this.tutorialCategoryId = response.data.data.categoryId;
      }).catch(err => {
        this.loading = false;
        this.$notify({
          type: 'error',
          text: 'Something went wrong while trying to get tutorial settings.'
        });
      });

      $('#tutorial-settings-modal').on('hidden.bs.modal', () => {
        this.$emit('display', false);
      });
    },
    inject: {
      $validator: '$validator'
    },
    methods: {
      removeTutorial() {
        this.loading = true;
        HTTP.post('/tutorials/remove', {
          id: this.id
        }).then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.loading = false;
            this.$emit('tutorial-removed', this.id);
            this.$emit('display', false);
            $('#tutorial-settings-modal').modal('hide');
          }
        })
          .catch(err => {
            this.$notify({
              type: 'error',
              text: 'Something went wrong while trying to remove category.'
            });
            $('#tutorial-settings-modal').modal('hide');
            this.$emit('display', false);
          });
      },
      updateSettings() {
        this.loading = true;
        HTTP.post('/tutorials/update', {
          'tutorialId': this.id,
          'tutorialData': this.tutorialData,
          'categoryId': this.tutorialCategoryId
        }).then(response => {
          ERROR(response);
          if (response.data.status === 'success') {
            this.loading = false;
            this.$emit('tutorial-updated', this.id);
            this.$emit('display', false);
            $('#tutorial-settings-modal').modal('hide');
          }
        })
          .catch(err => {
            this.$notify({
              type: 'error',
              text: 'Something went wrong while trying to update settings.'
            });
            $('#tutorial-settings-modal').modal('hide');
            this.$emit('display', false);
          });
      },
      inputFilter(newFile, oldFile, prevent) {
        if (newFile && !oldFile) {
          if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
            return prevent()
          }
          if (/\.(php5?|html?|jsx?)$/i.test(newFile.name)) {
            return prevent()
          }
        }
      },
      inputFile(newFile, oldFile) {
        if (newFile && !oldFile) {
          console.log('add', newFile)
        }
        if (newFile && oldFile) {
          console.log('update', newFile)
        }
        if (!newFile && oldFile) {
          console.log('remove', oldFile)
        }
        if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
          this.loadingThumb = true;
          if (!this.$refs.thumbUpload.active) {
            this.$refs.thumbUpload.active = true
          }
        }
      },
      thumbUrl() {
        if (this.tutorialData.thumbFile) {
          return BUCKET_URL + 'tutorials/' + this.tutorialData.thumbFile;
        }
        return '';
      }
    },
    watch: {
      thumb: function (thumb) {
        if (!thumb.length) {
          return;
        }
        if (thumb.every(item => item.success)) {
          this.tutorialData.thumbFile = thumb[thumb.length - 1].response.data.filename;
          this.loadingThumb = false;
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  .thumb-preview {
    width: 100%;
    margin-bottom: 10px;
    img {
      display: block;
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// TutorialSettingsModal.vue?177eae9d